import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { GlobalDataContext } from "../../context/context";
import {
  FaCreditCard,
  FaArrowRight
} from "react-icons/fa";
import { FiPhoneCall, FiMapPin, FiClock } from "react-icons/fi";
import { GoCalendar } from "react-icons/go";
import { ButtonContent } from "./boton/ButtonContent";

const menu = [
  {
    name: "Home",
    link: "/",
  },
  {
    name: "About",
    link: "/about",
  },
  {
    name: "Services",
    link: "/services",
  },
  {
    name: "Gallery",
    link: "/gallery",
  },
  {
    name: "Contact",
    link: "/contact",
  },
];

function Footer_2() {
  const { rpdata } = useContext(GlobalDataContext);

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <div className="w-full flex flex-col justify-center bg-gray-400 bg-opacity-5 p-8 py-14 bg-footer text-white">
        <div className="md:w-3/4 mx-auto text-center flex justify-center mb-4 md:flex-row flex-col-reverse">
          <div className="md:w-1/2 text-start self-center md:px-10">
            <h2 className="text-white md:pt-0 pt-6">{rpdata?.dbSlogan?.[0].slogan}</h2>
            <ButtonContent btnStyle="three" />
          </div>
          <div className="md:w-1/2 flex justify-center">
              <img
                src={rpdata?.dbPrincipal?.logo}
                className="w-[380px] h-[220px] py-4 px-6 rounded-xl"
                alt="Not Found"
              />
          </div>
        </div>
        <div className="md:w-4/5 mx-auto text-center flex justify-center">
          <ul className="flex flex-wrap">
            {menu.map((item, index) => {
              return (
                <li className="py-2 mx-3" onClick={goToTop} key={index}>
                  <Link to={item.link} className="flex">
                    <FaArrowRight className="self-center" />
                    <span className="pl-2">{item.name}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
        <div className="md:w-4/5 mx-auto">
          <div className="flex md:flex-row flex-col">
            <div className="pt-10 md:w-[35%]">
              <div className="bg-2 my-2 md:mx-6 p-6 rounded-2xl">
                <h5>About</h5>
                <p className="pb-4">
                  {rpdata?.dbAbout?.[1].text.substring(0, 211)}
                </p>
              </div>
            </div>
            <div className="pt-10 md:w-[40%]">
              <h5>Services</h5>
              <ul className="grid grid-cols-2 pl-1">
                {rpdata?.dbServices?.map((item, index) => {
                  return (
                    <li className="py-2" onClick={goToTop} key={index}>
                      <Link to="/" className="flex">
                        <FaArrowRight className="self-center" />
                        <span className="pl-2">{item.name}</span>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="pt-10 md:w-[25%]">
              <h5>Contact</h5>
              <ul className="pl-2">
                {rpdata?.dbPrincipal?.location.map((item, index) => {
                  return (
                    <Link to="/contact" key={index}>
                      <li className="py-2 flex items-center">
                        <FiMapPin fontSize={25} />
                        <span className="pl-3">{item.address}</span>
                      </li>
                    </Link>
                  );
                })}
                <a href={`tel:+1${rpdata?.dbPrincipal?.phones[0].phone}`}>
                  <li className="py-2 flex items-center">
                    <FiPhoneCall fontSize={25} />
                    <span className="pl-3">
                      {rpdata?.dbPrincipal?.phones[0].phone}
                    </span>
                  </li>
                </a>
                <li className="py-2 flex items-center">
                  <GoCalendar fontSize={25} />
                  <span className="pl-3">
                    {rpdata?.dbPrincipal?.workdays?.[0].day}
                  </span>
                </li>
                <li className="py-2 flex items-center">
                  <FiClock fontSize={25} />
                  <span className="pl-3">
                    {" "}
                    {rpdata?.dbPrincipal?.workHours?.[0].hour}
                  </span>
                </li>
                <li className="py-2 flex items-center">
                  <FaCreditCard />
                  <span className="pl-3">
                    {rpdata?.dbPrincipal?.paymentMethod}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full flex justify-around md:flex-row items-center flex-col-reverse text-center text-white  py-4 bg-2">
        <p>
          ©2022, Copy Right By {rpdata?.dbPrincipal?.name}. All Rights Reserved
        </p>
        <ul className="flex">
          {rpdata?.dbSocialMedia?.redes.map((item, index) => {
            return (
              <li key={index} className="mr-7">
                <a href={item.url} target="_blank" rel="noopener noreferrer">
                  <i className={`fab fa-${item.icon}`} aria-hidden="true" />
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
}

export default Footer_2;